// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__1lnP7","active":"Tooltip_active__3fdYb"};